<template>
  <el-dialog :visible.sync="dialogVisible" title="Load Filter">
    <el-table
      ref="loadTable"
      :data="filterData"
      highlight-current-row
      style="width: 100%"
      @current-change="handleCurrentChange"
    >
      <el-table-column property="title" label="Title" width="120"></el-table-column>
      <el-table-column property="survey" label="Survey"></el-table-column>
      <el-table-column property="user" label="User"></el-table-column>
      <el-table-column property="insertedAt" label="Created"></el-table-column>
      <el-table-column label>
        <template slot-scope="scope">
          <el-button size="mini" type="danger" @click="handleDelete(scope)">
            <i class="fa fa-fw fa-trash"></i>
          </el-button>
          <el-button size="mini" type="primary" @click="handleLoad()">Load</el-button>
        </template>
      </el-table-column>
    </el-table>

    <span slot="footer">
      <el-button @click="handleClose">Close</el-button>
    </span>
  </el-dialog>
</template>

<script>
import gql from 'graphql-tag';
import moment from 'moment';
import { get } from 'lodash';

export default {
  name: 'SurveyFilterLoadDialog',
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    currentSelection: null,
  }),
  apollo: {
    $client: 'apiv2',
    surveysFilterListSaved: {
      query: gql`
        {
          surveysFilterListSaved {
            id
            title
            insertedAt
            filter
            fields
            user {
              firstName
              lastName
            }
            survey {
              title
            }
          }
        }
      `,
    },
  },
  computed: {
    dialogVisible: {
      get() {
        return this.isVisible;
      },
      set(visiblity) {
        this.$emit('onVisibleChanged', visiblity);
      },
    },
    filterData() {
      if (!this.surveysFilterListSaved) {
        return [];
      }
      return this.surveysFilterListSaved.map(s => {
        const fullName = [get(s, 'user.firstName', ''), get(s, 'user.lastName', '')].join(' ');

        return {
          id: s.id,
          title: s.title,
          survey: get(s, 'survey.title', ''),
          insertedAt: moment(s.insertedAt).format('YYYY-MM-DD'),
          user: fullName,
          filter: s.filter,
          fields: s.fields,
        };
      });
    },
  },
  methods: {
    refresh() {
      this.$apollo.queries.surveyFilterListSaved.refetch();
    },
    handleClose() {
      this.$emit('onVisibleChanged', false);
    },
    handleCurrentChange(change) {
      this.currentSelection = change;
    },
    handleLoad() {
      // We want to ensure the handleCurrentChange runs
      // before we start the process of loading.
      setTimeout(() => {
        this.$emit('onLoad', [
          this.currentSelection.id,
          this.currentSelection.filter,
          this.currentSelection.fields,
        ]);
      }, 0);
    },
    handleDelete() {
      // We want to ensure the handleCurrentChange runs
      // before we start the process of deleting.
      setTimeout(() => {
        this.$confirm('This will permenantly delete this filter. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning',
        }).then(() => {
          this.$apollo
            .mutate({
              client: 'apiv2',
              mutation: gql`
                mutation($id: ID!) {
                  surveysFilterDeleteSaved(id: $id)
                }
              `,
              variables: {
                id: this.currentSelection.id,
              },
            })
            .then(() => {
              this.$notify({
                title: 'Success',
                message: 'Saved survey filter deleted.',
                type: 'success',
              });
              this.refresh();
            });
        });
      }, 0);
    },
  },
  watch: {
    isVisible(visibility) {
      if (visibility) {
        this.refresh();
      }
    },
  },
};
</script>


// WEBPACK FOOTER //
// SurveyFilterLoadDialog.vue?52c2c059